import * as actionTypes from "../actions/actionTypes";

const initState = {
  loading: false,
  chat: null,
  error: null,
  holdPulling: false,
  pagination_info: null,
  updating: false,
};

const initGetChat = (state, action) => {
  return {
    ...state,
    loading: action.loading,
  };
};

const initUpdateChat = (state, action) => {
  return {
    ...state,
    updating: action.updating,
  };
};

const successGetChat = (state, action) => {
  if (!state.holdPulling || action.ignoreHolding) {
    return {
      ...state,
      loading: action.loading,
      chat: action.chat,
      pagination_info: action.pagination_info,
      updating: action.updating,
    };
  } else {
    return {
      ...state,
    };
  }
};

const failGetChat = (state, action) => {
  return {
    ...state,
    loading: action.loading,
    error: action.error,
  };
};

const setHoldPulling = (state, action) => {
  return {
    ...state,
    holdPulling: action.holdPulling,
  };
};

const Reducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.INIT_GET_CHAT:
      return initGetChat(state, action);
    case actionTypes.INIT_UPDATE_CHAT:
      return initUpdateChat(state, action);
    case actionTypes.SUCCESS_GET_CHAT:
      return successGetChat(state, action);
    case actionTypes.FAIL_GET_CHAT:
      return failGetChat(state, action);
    case actionTypes.HOLD_PULLING:
      return setHoldPulling(state, action);
    default:
      return { ...state };
  }
};

export default Reducer;
